/* ═══════════════════════════════════════════════
   Kaalp Studios — Wishlist JS
   Pure localStorage — no app required
   ═══════════════════════════════════════════════ */
(function () {
  'use strict';

  var STORAGE_KEY = 'kaalp_wishlist';

  /* ── Core helpers ── */
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function isWishlisted(productId) {
    var list = getWishlist();
    return list.some(function (item) { 
      return String(item.id) === String(productId); 
    });
  }

  function addToWishlist(product) {
    var list = getWishlist();
    // Check for exact duplicates before adding
    var isDuplicate = list.some(function (i) { 
      return i.id === String(product.id) && i.url === product.url; 
    });
    if (!isDuplicate) {
      list.push(product);
      saveWishlist(list);
    }
  }

  function removeFromWishlist(productId) {
    var list = getWishlist().filter(function (item) { return item.id !== String(productId); });
    saveWishlist(list);
  }

  function toggleWishlist(product) {
    // Normalize product data for consistency
    var normalized = {
      id: String(product.id),
      url: (product.url || '').split('?')[0].toLowerCase(),
      title: (product.title || '').toLowerCase().trim()
    };
    
    var list = getWishlist();
    var exists = isWishlisted(normalized.id);
    
    
    if (exists) {
      removeFromWishlist(product.id);
      return false;
    } else {
      addToWishlist(product);
      return true;
    }
  }

  /* ── Badge counter in header ── */
  function updateBadge() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  /* ── Update all heart buttons on the page ── */
  function syncAllHearts() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = String(btn.getAttribute('data-wishlist-toggle'));
      var active = isWishlisted(id);
      btn.classList.toggle('is-wishlisted', active);
      btn.setAttribute('aria-pressed', String(active));
      /* Style handled via CSS class .is-wishlisted */
    });
    updateBadge();
  }

  /* ── Attach click handlers to all toggle buttons ── */
  function bindToggleButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      if (btn._wishlistBound) return;
      btn._wishlistBound = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var productId = btn.getAttribute('data-wishlist-toggle');
        var productTitle = btn.getAttribute('data-wishlist-title') || '';
        var productUrl = btn.getAttribute('data-wishlist-url') || '';
        var productImage = btn.getAttribute('data-wishlist-image') || '';
        var productPrice = btn.getAttribute('data-wishlist-price') || '';

        var added = toggleWishlist({ id: productId, title: productTitle, url: productUrl, image: productImage, price: productPrice });
        syncAllHearts();

        /* If on wishlist page and we just removed it, animate out and remove from DOM */
        var grid = document.getElementById('kaalp-wishlist-grid');
        if (grid && grid.contains(btn) && !added) {
          var card = btn.closest('.wishlist-card');
          if (card) {
            card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
            card.style.opacity = '0';
            card.style.transform = 'scale(0.9)';
            setTimeout(function () {
              card.remove();
              
              // Update wishlist count on page
              var wishlist = getWishlist();
              var countEl = document.getElementById('kaalp-wishlist-count');
              if (countEl) {
                countEl.textContent = wishlist.length + (wishlist.length === 1 ? ' item' : ' items');
              }
              
              // Toggle empty state if needed
              if (wishlist.length === 0) {
                grid.style.display = 'none';
                var emptyState = document.getElementById('kaalp-wishlist-empty');
                if (emptyState) emptyState.style.display = '';
              }
            }, 300);
          }
        }

        /* Micro-animation */
        btn.classList.add('is-bouncing');
        setTimeout(function () { btn.classList.remove('is-bouncing'); }, 400);

        /* Toast feedback disabled as requested */
        // showToast(added ? '❤️ Added to wishlist' : '🤍 Removed from wishlist');
      });
    });
  }

  /* ── Toast notification ── */
  function showToast(msg) {
    var existing = document.querySelector('.wishlist-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'wishlist-toast';
    toast.textContent = msg;
    toast.style.cssText = [
      'position:fixed', 'bottom:24px', 'left:50%', 'transform:translateX(-50%)',
      'background:#1a2744', 'color:#fff', 'padding:12px 24px',
      'border-radius:100px', 'font-size:13px', 'font-weight:600',
      'letter-spacing:0.05em', 'z-index:9999',
      'animation:wishlistToastIn 0.3s ease', 'box-shadow:0 8px 24px rgba(0,0,0,0.2)'
    ].join(';');
    document.body.appendChild(toast);
    setTimeout(function () {
      toast.style.animation = 'wishlistToastOut 0.3s ease forwards';
      setTimeout(function () { toast.remove(); }, 300);
    }, 2000);
  }

  /* ── Toast keyframes injected once ── */
  if (!document.getElementById('wishlist-toast-style')) {
    var s = document.createElement('style');
    s.id = 'wishlist-toast-style';
    s.textContent = [
      '@keyframes wishlistToastIn{from{opacity:0;transform:translateX(-50%) translateY(12px)}to{opacity:1;transform:translateX(-50%) translateY(0)}}',
      '@keyframes wishlistToastOut{from{opacity:1;transform:translateX(-50%) translateY(0)}to{opacity:0;transform:translateX(-50%) translateY(12px)}}',
      '.is-bouncing{animation:wishlist-bounce 0.4s ease!important}',
      '@keyframes wishlist-bounce{0%,100%{transform:scale(1)}40%{transform:scale(1.35)}70%{transform:scale(0.9)}}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ══════════════════════════════════════════════
     WISHLIST PAGE RENDERER (page.wishlist)
     Only runs when #kaalp-wishlist-grid exists
  ══════════════════════════════════════════════ */
  function renderWishlistPage() {
    var grid = document.getElementById('kaalp-wishlist-grid');
    var emptyState = document.getElementById('kaalp-wishlist-empty');
    var countEl = document.getElementById('kaalp-wishlist-count');
    if (!grid) return;

    var wishlist = getWishlist();

    // Deduplicate wishlist items
    var deduped = [];
    var seen = {};
    wishlist.forEach(function(item) {
      var key = String(item.id) + '|' + (item.url || '');
      if (!seen[key]) {
        seen[key] = true;
        deduped.push(item);
      }
    });
    
    // Save deduplicated list back to localStorage
    if (deduped.length !== wishlist.length) {
      saveWishlist(deduped);
      wishlist = deduped;
    }

    if (countEl) countEl.textContent = wishlist.length + (wishlist.length === 1 ? ' item' : ' items');

    if (wishlist.length === 0) {
      grid.style.display = 'none';
      if (emptyState) emptyState.style.display = '';
      return;
    }

    grid.style.display = '';
    if (emptyState) emptyState.style.display = 'none';
    grid.innerHTML = '';

    /* Fetch each product from AJAX API */
    var fetches = wishlist.map(function (item) {
      return fetch('/products/' + item.url.replace('/products/', '').split('?')[0] + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    });

    Promise.all(fetches).then(function (products) {
      products.forEach(function (product, i) {
        var saved = wishlist[i];
        var card = buildWishlistCard(product || saved);
        grid.appendChild(card);
      });
      bindToggleButtons();
      syncAllHearts();
    });
  }

  function buildWishlistCard(p) {
    /* Works with either a full product object (from AJAX) or a saved stub */
    var isStub = !p.variants;
    var id = isStub ? p.id : String(p.id);
    var title = isStub ? p.title : p.title;
    var url = isStub ? p.url : p.url;
    var image = isStub ? p.image : (p.featured_image || '');
    var price = isStub ? p.price : (p.price / 100).toFixed(2);
    var handle = isStub ? (p.url || '').replace('/products/', '') : p.handle;

    var imgSrc = image
      ? (typeof image === 'string' ? image : (image.src || ''))
      : '';

    /* Thumbnail URL sizing */
    if (imgSrc && imgSrc.indexOf('shopify') !== -1 && imgSrc.indexOf('_600x') === -1) {
      imgSrc = imgSrc.replace(/\.(jpg|jpeg|png|webp)(\?.*)?$/i, '_600x.$1$2');
    }

    var priceFormatted = '₹' + parseFloat(price).toLocaleString('en-IN', { minimumFractionDigits: 2 });

    var card = document.createElement('div');
    card.className = 'wishlist-card';
    card.innerHTML = [
      '<a href="' + url + '" class="wishlist-card__image-wrap">',
        imgSrc ? '<img src="' + imgSrc + '" alt="' + title + '" loading="lazy">' : '<div class="wishlist-card__placeholder"></div>',
      '</a>',
      '<div class="wishlist-card__info">',
        '<a href="' + url + '" class="wishlist-card__title">' + title + '</a>',
        '<div class="wishlist-card__price">' + priceFormatted + '</div>',
        '<div class="wishlist-card__actions">',
          '<a href="' + url + '" class="wishlist-card__shop-btn">Shop Now</a>',
          '<button class="wishlist-card__remove" data-wishlist-toggle="' + id + '" data-wishlist-title="' + title + '" data-wishlist-url="' + url + '" data-wishlist-image="' + imgSrc + '" data-wishlist-price="' + price + '" aria-label="Remove from wishlist" aria-pressed="true">',
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>',
          '</button>',
        '</div>',
      '</div>'
    ].join('');
    return card;
  }

  /* ── Init ── */
  function init() {
    // Auto-deduplicate on every page load
    var list = getWishlist();
    var seen = {};
    var deduped = [];
    
    list.forEach(function(item) {
      var key = String(item.id);
      if (!seen[key]) {
        seen[key] = true;
        deduped.push(item);
      }
    });
    
    if (deduped.length !== list.length) {
      saveWishlist(deduped);
    }
    
    bindToggleButtons();
    syncAllHearts();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-sync when Shopify section content changes (theme editor) */
  document.addEventListener('shopify:section:load', function () {
    bindToggleButtons();
    syncAllHearts();
  });

  /* Expose globally for other scripts */
  window.KaalpWishlist = {
    getWishlist: getWishlist,
    addToWishlist: addToWishlist,
    removeFromWishlist: removeFromWishlist,
    isWishlisted: isWishlisted,
    syncAllHearts: syncAllHearts,
    updateBadge: updateBadge
  };
})();
